import type { RobokassaPaymentSession } from '@bookclub/shared';

const PURCHASE_ATTEMPT_STORAGE_KEY = 'inhound:payments:last-order';

export type StoredPurchaseAttempt = {
  orderId: string;
  clubId: string;
  paywallSlug: string | null;
  source: string | null;
  chapterId?: string | null;
  demoContext?: string | null;
  createdAt: string;
};

export function rememberPurchaseAttempt(attempt: StoredPurchaseAttempt) {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(PURCHASE_ATTEMPT_STORAGE_KEY, JSON.stringify(attempt));
}

export function readPurchaseAttempt(): StoredPurchaseAttempt | null {
  if (typeof window === 'undefined') return null;

  const raw = window.sessionStorage.getItem(PURCHASE_ATTEMPT_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as StoredPurchaseAttempt;
  } catch {
    window.sessionStorage.removeItem(PURCHASE_ATTEMPT_STORAGE_KEY);
    return null;
  }
}

export function clearPurchaseAttempt() {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(PURCHASE_ATTEMPT_STORAGE_KEY);
}

export function submitHostedPaymentSession(session: RobokassaPaymentSession) {
  const form = document.createElement('form');
  form.method = session.method;
  form.action = session.action;
  form.style.display = 'none';

  for (const [key, value] of Object.entries(session.fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);

  try {
    form.submit();
  } finally {
    document.body.removeChild(form);
  }
}
